<h1 mat-dialog-title [attr.data-cy]="'mkmkdmkd_h1_1_4_'">{{ input?.titel }} auswählen</h1>
<div mat-dialog-content>
    <kiene-meine-kontakte
        (kontaktAusgewaehlt)="setContact($event)"
        [kunde_id]="input?.kunde_id_a"
        [extern]="input?.extern"
        [intern]="input?.intern"
        [schlachthof]="input?.schlachthof"
        [neuenKontaktErstellen]="!input.schlachthof"
        [titel]="input?.titel"
    >
    </kiene-meine-kontakte>
</div>
<div mat-dialog-actions align="end">
    <button (click)="close()" mat-button [attr.data-cy]="'mkmkdmkd_button_1_0_'">Abbrechen</button>
</div>
